<script setup lang="ts">
/**
 * UI-kit component
 * Category: Dropdown
 * Name: 'AppDropdownLoader'
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=16179-261185
 */

defineOptions({
  name: 'AppDropdownLoader',
})
</script>

<template>
  <div
    class="app-dropdown-loader"
    role="status"
    aria-label="Loading more items"
  >
    <span
      class="app-dropdown-loader__dots"
      aria-hidden="true"
    />
  </div>
</template>

<style scoped lang="scss" src="../styles/_app-dropdown-loader.scss" />
